"use client"

import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import {
  Check 
} from "lucide-react"
import * as React from "react"

import {
  cn 
} from "@/lib/utils"

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({
  className, ...props 
}, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "border-primary ring-offset-background focus-visible_outline-none focus-visible_ring-2 focus-visible_ring-ring focus-visible_ring-offset-2 disabled_cursor-not-allowed disabled_opacity-50 data-[state=checked]_bg-primary data-[state=checked]_text-primary-foreground peer h-4 w-4 shrink-0 rounded-sm border",
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("flex items-center justify-center text-current")}
    >
      <Check className='h-4 w-4 text-white' />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))

Checkbox.displayName = CheckboxPrimitive.Root.displayName

export {
  Checkbox 
}

